<template>
  <v-container fluid>
    <v-row class="subtitle-2 text--primary">
      <v-col cols="12" md="5">
        <div style="font-weight: bold; font-size: 18px">System Generated</div>

        <!-- start of sales -->
        <v-row class="mt-2" v-if="hideTotals != 'Y'">
          <v-col cols="12">
            <div style="font-weight: bold; font-size: 14px">Sales Summary</div>
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total Sales</td>
                    <td class="text-right">{{ zReport.TotalSales && zReport.TotalSales | currency }}</td>
                  </tr>
                  <tr>
                    <td>Total Delivery Cost</td>
                    <td class="text-right">{{ zReport.TotalDeliveryCost && zReport.TotalDeliveryCost | currency }}</td>
                  </tr>
                  <tr>
                    <td>Total Payments</td>
                    <td class="text-right">{{ zReport.TotalSalesPayment && zReport.TotalSalesPayment | currency }}</td>
                  </tr>

                  <tr>
                    <td>Credit Sales</td>
                    <td class="text-right" v-if="zReport.TotalCreditSales > 0">{{ zReport.TotalCreditSales &&
                      zReport.TotalCreditSales | currency }}</td>
                    <td class="text-right" v-else> 0.0 </td>
                  </tr>

                  <tr>
                    <td>Cash Back</td>
                    <td class="text-right" v-if="zReport.TotalCashBack > 0">{{ zReport.TotalCashBack &&
                      zReport.TotalCashBack | currency }}</td>
                    <td class="text-right" v-else> 0.0 </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <!-- end of sales -->

        <!-- start of sale payments summary -->
        <v-row class="mt-2" v-if="hideTotals != 'Y'">
          <v-col cols="12">
            <div style="font-weight: bold; font-size: 14px">Sale Payments Summary</div>
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, index) in zReport.SalePayments" :key="index">
                    <td>{{ item.Account }}</td>
                    <td class="text-right">{{ item.TotalAmount && item.TotalAmount | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <!-- end of sales payments -->

        <!-- start of debt payments summary -->
        <v-row class="mt-2" v-if="hideTotals != 'Y'">
          <v-col cols="12">
            <div style="font-weight: bold; font-size: 14px">Debt Payments Summary</div>
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, index) in zReport.debtPayments" :key="index">
                    <td>{{ item.Account }}</td>
                    <td class="text-right">{{ item.TotalAmount && item.TotalAmount | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <!-- end of debt payments-->

        <!-- start of purchases -->
        <v-row class="mt-2" v-if="hideTotals != 'Y'">
          <v-col cols="12">
            <div style="font-weight: bold; font-size: 14px">Purchases Summary</div>
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total Purchases</td>
                    <td class="text-right">{{ zReport.TotalPurchases && zReport.TotalPurchases | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <!-- end of purchases -->

        <!-- start of cash transactions summary -->
        <v-row class="mt-2">
          <v-col cols="12">
            <div style="font-weight: bold; font-size: 14px">Cash Transactions Summary</div>
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Starting Float</td>
                    <td class="text-right">{{ zReport.StartingFloat && zReport.StartingFloat | currency }}</td>
                  </tr>

                  <tr>
                    <td>Cash Payments (Sales)</td>
                    <td class="text-right">{{ zReport.TotalSalesCashPayment && zReport.TotalSalesCashPayment | currency
                      }}</td>
                  </tr>

                  <tr>
                    <td>Delivery Cost</td>
                    <td class="text-right">{{ zReport.TotalDeliveryCost && zReport.TotalDeliveryCost | currency }}</td>
                  </tr>

                  <tr>
                    <td>Cash Back</td>
                    <td class="text-right">{{ zReport.TotalCashBack && zReport.TotalCashBack | currency }}</td>
                  </tr>

                  <tr>
                    <td>Cash Payments (Purchases)</td>
                    <td class="text-right">{{ zReport.TotalPurchasesCashPayment && zReport.TotalPurchasesCashPayment |
                      currency }}</td>
                  </tr>

                  <tr>
                    <td>Cash Expenses</td>
                    <td class="text-right">{{ zReport.TotalCashExpenses && zReport.TotalCashExpenses | currency }}</td>
                  </tr>

                  <tr>
                    <td>Cash Transfers</td>
                    <td class="text-right">{{ zReport.TotalCashTransfers && zReport.TotalCashTransfers | currency }}
                    </td>
                  </tr>

                  <tr>
                    <td>Cash At Hand</td>
                    <td class="text-right">
                      <span>{{ zReport.CashAtHand && zReport.CashAtHand | currency }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <!-- end of sales -->
      </v-col>

      <v-col cols="12" md="6">
        <div style>
          <v-row>
            <div class="mt-2 ml-3 float-right" style="font-size: 20px; font-weight: bold">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="date" label="From" prepend-icon="mdi-calendar-month"
                    v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker @change="getZReport" v-model="date" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </div>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-data-table dense :mobile-breakpoint="0" :headers="closingHeaders" :items="closingData"
                hide-default-footer>
                <template v-slot:item.amount="{ item }">
                  <span>{{ item.amount.toLocaleString() }}</span>
                </template>
                <template v-slot:item.total="{ item }">
                  <span>{{ (item.denomination * item.amount) }}</span>
                </template>
              </v-data-table>

              <div style="font-size: 20px; font-weight: bold"></div>
            </v-col>

            <v-col cols="12">
              <div style="font-size: 16px; font-weight: bold; float: right">Total Closing: {{ TotalClosing | currency }}
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-row class="subtitle-2 text--primary">
      <v-col cols="12">
        <div>Manual Total Closing: {{ TotalClosing | currency }}</div>
        <div v-if="zVariance != 0" style="color: red">Variance: {{ zVariance | currency }}</div>
        <div v-if="zVariance == 0" style="color: green">Variance: {{ zVariance | currency }}</div>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>

  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    zReport: {},
    closingData: [],
    TotalClosing: 0,
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    headers: [
      { text: "Category", value: "vpm1.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Account", value: "account.Name" },
      { text: "Description", value: "Description" },
      { text: "Date", value: "DocDate" }
    ],
    closingHeaders: [
      { text: "Title", value: "denomination", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Total", value: "total", sortable: false }
    ],
    expenses: [],
    TotalExpenses: null
  }),
  computed: {
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    zVariance() {
      return this.zReport.CashAtHand - this.TotalClosing;
    }
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    getZReport() {
      let data = {};
      data.date = this.date;
      const self = this;
      const url = `/z-report`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.zReport = res.ResponseData;
            self.closingData = res.ResponseData.closingData;
            self.TotalClosing = res.ResponseData.totalClosing;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });

    },
  },
  created() {
    Promise.all([this.getZReport()]);
  }
};
</script>